import React from "react";
import loaderImg from "../../Image/load.webp";

const Loader = () => {
  return (
    <div className="py-24">
      <div className="flex justify-center items-center">
        <img width="150" src={loaderImg} alt="" /> <h3>Loading....</h3>
      </div>
    </div>
  );
};

export default Loader;
